import "./3dComponents.css";
import React, { useEffect } from "react";
import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";

import ColorChange from "../EggComponent/ColorChange";

import { gsap } from "gsap";

const fragShade = `
    uniform float u_time;

    void main() {
    	gl_FragColor = vec4(abs(sin(u_time)),0.0,0.344,1.0);
    }
`;

const vertShade = `
void main() {
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
}
`;

export default function ThreeDeeComponent() {
  useEffect(() => {
    const scene = new THREE.Scene();
    const raycaster = new THREE.Raycaster();
    const mouse = new THREE.Vector2();
    const sizes = {
      width: window.innerWidth,
      height: window.innerHeight,
    };
    const camera = new THREE.PerspectiveCamera(
      50,
      sizes.width / sizes.height,
      125,
      3000000
    );
    const camera2 = new THREE.PerspectiveCamera(
      90,
      sizes.width / sizes.height,
      1,
      5000
    );
    const renderer = new THREE.WebGL1Renderer({
      canvas: document.querySelector("#bg"),
    });

    renderer.setSize(sizes.width, sizes.height);
    document.body.appendChild(renderer.domElement);

    const pointLight = new THREE.PointLight("orange", 0.5, 0);
    pointLight.position.set(0, 0, 2000);
    const ambientLight = new THREE.AmbientLight(0xffffff, 1);
    scene.add(pointLight, ambientLight);

    camera2.position.x = -10;
    camera2.position.y = 8;

    var gameObject = [];
    const loader = new GLTFLoader();
    loader.load(require("./hidden/spaceship.gltf"), function (gltf) {
      const model = gltf.scene.children[0];
      model.position.set(0, 0, 0);
      gameObject.push(model);
      camera2.lookAt(model.position.x, model.position.y, model.position.z);
      scene.add(gltf.scene);
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "ArrowUp") {
        gameObject[0].position.x += 1;
        camera2.position.x += 1;
      } else if (event.key === "ArrowDown") {
        gameObject[0].position.x -= 1;
        camera2.position.x -= 1;
      } else if (event.key === "ArrowRight") {
        gameObject[0].position.z += 1;
        camera2.position.z += 1;
      } else if (event.key === "ArrowLeft") {
        gameObject[0].position.z -= 1;
        camera2.position.z -= 1;
      }
    });

    camera.position.z = 1500;

    window.addEventListener(`resize`, () => {
      renderer.setSize(window.innerWidth, window.innerHeight);
      camera.aspect = window.innerWidth / window.innerHeight;
      camera2.aspect = window.innerWidth / window.innerHeight;
      camera.updateProjectionMatrix();
      camera2.updateProjectionMatrix();
    });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

    window.addEventListener("scroll", () => {
      const t = document.body.getBoundingClientRect().top;
      camera.position.z = t * -0.5 + 1500;
      camera.rotation.z = t * -0.001;
      //scene.background.rotation = t*-0.001;
    });
    //kfitvuec0hs

    function randomColour(size) {
      return (
        "#" +
        [...Array(size)]
          .map(() => Math.floor(Math.random() * 16).toString(16))
          .join("")
      );
    }

    const star = [];
    for (var i = -1000; i < 1000; i += 2) {
      const rad = THREE.MathUtils.randFloatSpread(25) + 25;
      const geometry = new THREE.BoxGeometry(rad, rad, rad);
      const material = new THREE.MeshLambertMaterial({
        color: randomColour(6),
        wireframe: true,
      });
      const starM = new THREE.Mesh(geometry, material);
      starM.name = "star";
      starM.scale.z = 5;
      starM.scale.x = starM.scale.y = 0.1;

      const x = THREE.MathUtils.randFloatSpread(50) * 45 + 55;
      const y = THREE.MathUtils.randFloatSpread(50) * 45 + 55;
      starM.position.z = i * 2;
      starM.position.set(x, y);
      star.push(starM);
      scene.add(starM);
    }

    var uniforms = {
      u_time: { value: 0.0 },
    };

    for (var e = -500; e < 500; e += 15) {
      const rad = THREE.MathUtils.randFloatSpread(25) + 25;
      const geometry = new THREE.BoxGeometry(rad, rad, rad);
      const material = new THREE.ShaderMaterial({
        vertexShader: vertShade,
        fragmentShader: fragShade,
        uniforms,
      });
      const starM = new THREE.Mesh(geometry, material);
      starM.name = "box";
      starM.scale.x = starM.scale.y = starM.scale.z = 4;
      const x = THREE.MathUtils.randFloatSpread(50) * 45;
      const y = THREE.MathUtils.randFloatSpread(50) * 45;
      const z = THREE.MathUtils.randFloatSpread(500) * 8 + 50;
      starM.position.set(x, y, z);
      star.push(starM);
      scene.add(starM);
    }

    // Mouse event to cast a vector to interact with background objects
    function onMouseMove(event) {
      mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
      mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
      raycaster.setFromCamera(mouse, camera);
      var intersects = raycaster.intersectObjects(scene.children, false);
      if (intersects.length > 0) {
        for (var i = 0; i < intersects.length; i++) {
          this.tl = gsap.timeline();
          this.tl.to(intersects[i].object.rotation, 0.5, {
            z: Math.random(),
            ease: "power1.inOut",
          });
        }
      }
    }

    window.addEventListener("mousedown", onMouseMove);

    //create 3js skybox
    const skybox = new THREE.CubeTextureLoader().load([
      require("./skybox/right.png"),
      require("./skybox/left.png"),
      require("./skybox/top.png"),
      require("./skybox/bottom.png"),
      require("./skybox/front.png"),
      require("./skybox/back.png"),
    ]);
    scene.background = skybox;

    var ship = false;
    window.addEventListener(`submit`, () => {
      var x = document.getElementById("egg").value;
      x = x.toLowerCase();

      if (x === "secret") 
      ship = true;
      else ship = false;
      for (var z = 1000; z < star.length; z++) {
        star[z].material = new THREE.ShaderMaterial({
          vertexShader: vertShade,
          fragmentShader: ColorChange(x),
          uniforms,
        });
      }
    });

    const clock = new THREE.Clock();
    
    //Animate the scene
    function animate() {
      uniforms.u_time.value = clock.getElapsedTime();
      for (var i = 0; i < star.length; i++) {
        let particle = star[i];
        particle.position.z += 2;
        if (particle.position.z > 2000) {
          particle.position.z -= 3000;
        }
      }
      window.requestAnimationFrame(animate);
      if (!ship) renderer.render(scene, camera);
      else renderer.render(scene, camera2);
    }
    animate();
  }, []);

  return <canvas id="bg"></canvas>;
}
